/** ----------------------------------------
    Transitions
 ---------------------------------------- */

import * as transition from './transitions/illustrations';

/* ----------------------------------------
    Icons
---------------------------------------- */

export class Icons {
    init() {
        const buttons = document.querySelectorAll('.anp__icon');

        [...buttons].map(button => {
            const type = button.dataset.icon;

            const enterButton = () => transition[type].play();
            const leaveButton = () => transition[type].leave();

            button.addEventListener('mouseenter', enterButton, false);
            button.addEventListener('mouseleave', leaveButton, false);
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/cases/anp/Icons.js